module.exports = __webpack_public_path__ + "img/photo-film.a64e3d21.svg";